// import {
//   Button,
//   Dialog,
//   DialogFooter,
//   DialogHeader,
//   Input,
//   Option,
//   Select,
// } from "@material-tailwind/react";
// import React, { useEffect, useState } from "react";
// import { CREATE_MACHINE_URL, UPDATE_MACHINE_URL } from "../Constants";
// import axios from "../api/axios";
// import { useStore } from "../store/Zustand";
// import { useAuth } from "../store/auth";
// import { useNavigate } from "react-router";

// function MachineForm() {
//   // to close machine create form
//   const open = useStore((state) => state.open);
//   const setOpen = useStore((state) => state.setOpen);
//   const setNotify = useStore((state) => state.setNotify);
//   const token = useAuth((state) => state.token);
//   const resetAuth = useAuth((state) => state.resetAuth);

//   const navigate = useNavigate();

//   // edit machine
//   const set_result = useStore((state) => state.set_result);
//   const is_edit = useStore((state) => state.is_edit);
//   const set_edit = useStore((state) => state.set_edit);
//   const is_disabled = useStore((state) => state.is_disabled);
//   const set_disabled = useStore((state) => state.set_disabled);
//   const edit_data = useStore((state) => state.edit_data);
//   const edit_machine_data = useStore((state) => state.edit_machine_data);

//   // new machine values
//   const [new_machine_status, set_new_Machine_Status] = useState("1");
//   const [new_machine, set_new_Machine] = useState({
//     machine_code: "",
//     machine_name: "",
//     machine_number: "",
//     machine_version: "",
//     software_version: "",
//     last_service: "",
//   });

//   const create_machine = async () => {
//     const form = {
//       unit_id: 1,
//       machine_code: new_machine.machine_code,
//       machine_name: new_machine.machine_name,
//       machine_number: new_machine.machine_number,
//       machine_status: new_machine_status,
//       machine_version: new_machine.machine_version,
//       software_version: new_machine.software_version,
//       // last_service: new_machine.last_service,
//     };
//     await axios
//       .post(CREATE_MACHINE_URL, form, {
//         headers: {
//           "Content-Type": "application/json",
//           "x-access-tokens": token,
//         },
//       })
//       .then((response) => {
//         setNotify({ status: 1, message: response.data.status_message });
//         set_result(response.data.data);
//       })
//       .catch((error) => {
//         setNotify({ status: 2, message: error.response.data.status_message });
//         set_result(error.response.data);
//         if (error.response.status === 400) {
//           alert(error.response.data.status_message);
//         } else if (error.response.status === 403) {
//           alert(error.response.data.status_message);
//           resetAuth()
//           navigate("/generateOTP")
//         } else {
//           alert(error.response.data.status_message);
//         }
//       });
//     setOpen(!open);
//     setTimeout(() => {
//       setNotify({ status: 0, message: "" });
//     }, 2000);
//     set_new_Machine({
//       machine_code: "",
//       machine_name: "",
//       machine_number: "",
//       machine_version: "",
//       software_version: "",
//       last_service: "",
//     });
//   };

//   const update_machine = async () => {
//     const form = {
//       unit_id: 1,
//       machine_id: edit_data.id,
//       machine_code: edit_data.machine_code,
//       machine_name: edit_data.machine_name,
//       machine_number: edit_data.machine_number,
//       machine_status: new_machine_status,
//       machine_version: edit_data.machine_version,
//       software_version: edit_data.software_version,
//       // last_service: edit_data.last_service,
//     };
//     await axios
//       .put(UPDATE_MACHINE_URL, form, {
//         headers: {
//           "Content-Type": "application/json",
//           "x-access-tokens": token,
//         },
//       })
//       .then((response) => {
//         set_result(response.data.data);
//       })
//       .catch((error) => {
//         if (error.status === 304) {
//           // console.log(error)
//           alert("unable to update the status");
//         } else if (error.response.status === 403) {
//           alert(error.response.data.status_message);
//           resetAuth()
//           navigate("/generateOTP")
//         } else {
//           alert("Server is Down");
//         }
//       });
//     setOpen(!open);
//     set_edit(false);
//   };

//   const handleChange = (e) => {
//     if (is_edit) {
//       edit_machine_data({
//         ...edit_data,
//         [e.target.name]: e.target.value,
//       });
//     } else {
//       set_new_Machine({
//         ...new_machine,
//         [e.target.name]: e.target.value,
//       });
//     }
//   };

//   useEffect(() => {
//     // console.log(new_machine);
//     // console.log(edit_data);
//     // console.log(is_edit);
//     // console.log(new_machine_status);
//     // console.log(is_disabled);
//   }, [new_machine, new_machine_status, is_edit, edit_data, is_disabled]);

//   return (
//     <>
//       <Dialog
//         open={open}
//         handler={() => {
//           set_edit(false);
//           setOpen(!open);
//           set_new_Machine({
//             machine_code: "",
//             machine_name: "",
//             machine_number: "",
//             machine_version: "",
//             software_version: "",
//             // last_service: "",
//           });
//         }}
//         className="bg-transparent shadow-none m-4 rounded-lg bg-white"
//         style={{ maxWidth: "31%", minWidth: "31%" }}
//       >
//         <DialogHeader>
//           <span className="w-full text-center"> Machine Form </span>
//         </DialogHeader>
//         <div className="w-full">
//           <form className="p-6 bg-white rounded shadow-md py-8">
//             <div>
//               <div className="mb-4">
//                 <Input
//                   size="lg"
//                   name="machine_code"
//                   label="Machine Code"
//                   color="blue"
//                   required
//                   value={
//                     is_edit ? edit_data.machine_code : new_machine.machine_code
//                   }
//                   onChange={handleChange}
//                   disabled={is_disabled}
//                 />
//               </div>

//               <div className="mb-4">
//                 <Input
//                   size="lg"
//                   name="machine_name"
//                   label="Machine Name"
//                   color="blue"
//                   required
//                   value={
//                     is_edit ? edit_data.machine_name : new_machine.machine_name
//                   }
//                   onChange={handleChange}
//                   disabled={is_disabled}
//                 />
//               </div>
//               <div className="mb-4">
//                 <Input
//                   size="lg"
//                   name="machine_number"
//                   label="Machine Number"
//                   color="blue"
//                   required
//                   value={
//                     is_edit
//                       ? edit_data.machine_number
//                       : new_machine.machine_number
//                   }
//                   onChange={handleChange}
//                   disabled={is_disabled}
//                 />
//               </div>

//               <div className="mb-4">
//                 <Select
//                   label="Machine Status"
//                   color="blue"
//                   onChange={(e) => {
//                     set_new_Machine_Status(e);
//                   }}
//                   value={is_edit ? String(edit_data.machine_status) : "1"}
//                   placeholder="Select Machine Status"
//                   disabled={is_disabled}
//                   required
//                 >
//                   <Option value="0">OFF</Option>
//                   <Option value="1">IDLE</Option>
//                   <Option value="2">IN USE</Option>
//                   <Option value="3">OUT OF ORDER</Option>
//                   <Option value="4">NEED MAINTENANCE</Option>
//                   <Option value="5">IN MAINTENANCE</Option>
//                 </Select>
//               </div>
//               <div className="mb-4">
//                 <Input
//                   size="lg"
//                   name="machine_version"
//                   label="Machine Version"
//                   color="blue"
//                   required
//                   value={
//                     is_edit
//                       ? edit_data.machine_version
//                       : new_machine.machine_version
//                   }
//                   onChange={handleChange}
//                   disabled={is_disabled}
//                 />
//               </div>

//               <div className="mb-4">
//                 <Input
//                   size="lg"
//                   name="software_version"
//                   label="Software Version"
//                   color="blue"
//                   required
//                   value={
//                     is_edit
//                       ? edit_data.software_version
//                       : new_machine.software_version
//                   }
//                   onChange={handleChange}
//                   disabled={is_disabled}
//                 />
//               </div>

//               {/* <div className="mb-4">
//                 <Input
//                   size="lg"
//                   type="date"
//                   name="last_service"
//                   label="Last Service"
//                   value={
//                     is_edit ? edit_data.last_service : new_machine.last_service
//                   }
//                   onChange={handleChange}
//                   disabled={is_disabled}
//                 />
//               </div> */}
//             </div>
//           </form>
//           <DialogFooter>
//             <div className="flex flex-row content-end">
//               <Button
//                 className="mr-1 bg-green-600 text-white hover:bg-gray-600"
//                 onClick={
//                   is_edit
//                     ? is_disabled
//                       ? () => {
//                         set_disabled(false);
//                       }
//                       : update_machine
//                     : create_machine
//                 }
//               >
//                 {is_edit ? (is_disabled ? `Edit` : `Save`) : `Submit`}
//               </Button>
//               <Button
//                 className="mr-1 bg-red-600 text-white hover:bg-gray-600"
//                 onClick={() => {
//                   set_edit(false);
//                   setOpen(!open);
//                   set_new_Machine({
//                     machine_code: "",
//                     machine_name: "",
//                     machine_number: "",
//                     machine_version: "",
//                     software_version: "",
//                     // last_service: "",
//                   });
//                 }}
//               >
//                 <span>Cancel</span>
//               </Button>
//             </div>
//           </DialogFooter>
//         </div>
//       </Dialog>
//     </>
//   );
// }

// export default MachineForm;

import {
  Button,
  Dialog,
  DialogFooter,
  DialogHeader,
  Input,
  Option,
  Select,
} from "@material-tailwind/react";
import React, { useEffect, useState } from "react";
import { CREATE_MACHINE_URL, UPDATE_MACHINE_URL } from "../Constants";
import axios from "../api/axios";
import { useStore } from "../store/Zustand";
import { useAuth } from "../store/auth";
import { useNavigate } from "react-router";

function MachineForm() {
  const open = useStore((state) => state.open);
  const setOpen = useStore((state) => state.setOpen);
  const setNotify = useStore((state) => state.setNotify);
  const token = useAuth((state) => state.token);
  const resetAuth = useAuth((state) => state.resetAuth);

  const navigate = useNavigate();

  const set_result = useStore((state) => state.set_result);
  const is_edit = useStore((state) => state.is_edit);
  const set_edit = useStore((state) => state.set_edit);
  const is_disabled = useStore((state) => state.is_disabled);
  const set_disabled = useStore((state) => state.set_disabled);
  const edit_data = useStore((state) => state.edit_data);
  const edit_machine_data = useStore((state) => state.edit_machine_data);

  const [new_machine_status, set_new_Machine_Status] = useState("1");
  const [new_machine, set_new_Machine] = useState({
    machine_code: "",
    machine_name: "",
    machine_number: "",
    machine_version: "",
    software_version: "",
    last_service: "",
  });

  const create_machine = async () => {
    const form = {
      unit_id: 1,
      machine_code: new_machine.machine_code,
      machine_name: new_machine.machine_name,
      machine_number: new_machine.machine_number,
      machine_status: new_machine_status,
      machine_version: new_machine.machine_version,
      software_version: new_machine.software_version,
    };
    await axios
      .post(CREATE_MACHINE_URL, form, {
        headers: {
          "Content-Type": "application/json",
          "x-access-tokens": token,
        },
      })
      .then((response) => {
        setNotify({ status: 1, message: response.data.status_message });
        set_result(response.data.data);
      })
      .catch((error) => {
        setNotify({ status: 2, message: error.response.data.status_message });
        set_result(error.response.data);
        if (error.response.status === 400) {
          alert(error.response.data.status_message);
        } else if (error.response.status === 403) {
          alert(error.response.data.status_message);
          resetAuth();
          navigate("/generateOTP");
        } else {
          alert(error.response.data.status_message);
        }
      });
    setOpen(false);
    setTimeout(() => {
      setNotify({ status: 0, message: "" });
    }, 2000);
    set_new_Machine({
      machine_code: "",
      machine_name: "",
      machine_number: "",
      machine_version: "",
      software_version: "",
      last_service: "",
    });
  };

  const update_machine = async () => {
    const form = {
      unit_id: 1,
      machine_id: edit_data.id,
      machine_code: edit_data.machine_code,
      machine_name: edit_data.machine_name,
      machine_number: edit_data.machine_number,
      machine_status: new_machine_status,
      machine_version: edit_data.machine_version,
      software_version: edit_data.software_version,
    };
    await axios
      .put(UPDATE_MACHINE_URL, form, {
        headers: {
          "Content-Type": "application/json",
          "x-access-tokens": token,
        },
      })
      .then((response) => {
        set_result(response.data.data);
      })
      .catch((error) => {
        if (error.status === 304) {
          alert("Unable to update the status");
        } else if (error.response.status === 403) {
          alert(error.response.data.status_message);
          resetAuth();
          navigate("/generateOTP");
        } else {
          alert("Server is Down");
        }
      });
    setOpen(false);
    set_edit(false);
  };

  const handleChange = (e) => {
    if (is_edit) {
      edit_machine_data({
        ...edit_data,
        [e.target.name]: e.target.value,
      });
    } else {
      set_new_Machine({
        ...new_machine,
        [e.target.name]: e.target.value,
      });
    }
  };

  return (
    <Dialog
      open={open}
      handler={() => {
        set_edit(false);
        setOpen(false);
        set_new_Machine({
          machine_code: "",
          machine_name: "",
          machine_number: "",
          machine_version: "",
          software_version: "",
        });
      }}
      className="bg-white shadow-none rounded-lg w-full max-w-[95%] sm:max-w-[90%] md:max-w-[70%] lg:max-w-[40%] mx-auto"
    >
      <DialogHeader>
        <span className="w-full text-center"> Machine Form </span>
      </DialogHeader>

      <div className="w-full">
        <form className="p-4 sm:p-6 bg-white rounded shadow-md py-6 space-y-4">
          <Input
            size="lg"
            name="machine_code"
            label="Machine Code"
            color="blue"
            required
            value={
              is_edit ? edit_data.machine_code : new_machine.machine_code
            }
            onChange={handleChange}
            disabled={is_disabled}
          />
          <Input
            size="lg"
            name="machine_name"
            label="Machine Name"
            color="blue"
            required
            value={
              is_edit ? edit_data.machine_name : new_machine.machine_name
            }
            onChange={handleChange}
            disabled={is_disabled}
          />
          <Input
            size="lg"
            name="machine_number"
            label="Machine Number"
            color="blue"
            required
            value={
              is_edit ? edit_data.machine_number : new_machine.machine_number
            }
            onChange={handleChange}
            disabled={is_disabled}
          />
          <Select
            label="Machine Status"
            color="blue"
            onChange={(e) => set_new_Machine_Status(e)}
            value={is_edit ? String(edit_data.machine_status) : "1"}
            placeholder="Select Machine Status"
            disabled={is_disabled}
            required
          >
            <Option value="0">OFF</Option>
            <Option value="1">IDLE</Option>
            <Option value="2">IN USE</Option>
            <Option value="3">OUT OF ORDER</Option>
            <Option value="4">NEED MAINTENANCE</Option>
            <Option value="5">IN MAINTENANCE</Option>
          </Select>
          <Input
            size="lg"
            name="machine_version"
            label="Machine Version"
            color="blue"
            required
            value={
              is_edit
                ? edit_data.machine_version
                : new_machine.machine_version
            }
            onChange={handleChange}
            disabled={is_disabled}
          />
          <Input
            size="lg"
            name="software_version"
            label="Software Version"
            color="blue"
            required
            value={
              is_edit
                ? edit_data.software_version
                : new_machine.software_version
            }
            onChange={handleChange}
            disabled={is_disabled}
          />
        </form>

        <DialogFooter>
          <div className="flex flex-col sm:flex-row gap-2 sm:justify-end w-full">
            <Button
              className="bg-green-600 text-white hover:bg-gray-600"
              onClick={
                is_edit
                  ? is_disabled
                    ? () => set_disabled(false)
                    : update_machine
                  : create_machine
              }
            >
              {is_edit ? (is_disabled ? `Edit` : `Save`) : `Submit`}
            </Button>
            <Button
              className="bg-red-600 text-white hover:bg-gray-600"
              onClick={() => {
                set_edit(false);
                setOpen(false);
                set_new_Machine({
                  machine_code: "",
                  machine_name: "",
                  machine_number: "",
                  machine_version: "",
                  software_version: "",
                });
              }}
            >
              Cancel
            </Button>
          </div>
        </DialogFooter>
      </div>
    </Dialog>
  );
}

export default MachineForm;